module.exports = __webpack_public_path__ + "r-v3/img/exam_obj_white.ecef518d.svg";